import { Show } from 'solid-js';
import './error-modal.scss'
import ButtonAtomComponent from '../../components/atoms/button-atom/button-atom-component.jsx'
import ModalOrganismComponent from '../../components/organisms/modal-organism/modal-organism-component.jsx'
import ErrorModel from '../../../models/ErrorModel.js'
import { useIntl } from '@cookbook/solid-intl'
import { messages } from './error-modal.messages.en.js'

export default function ErrorModal (props) {
    const intl = useIntl()

    return (
        <ModalOrganismComponent
            class="error-modal"
            title={intl.formatMessage(messages.title)}
            onClose={props.onClose}
            seamlessSections={true}
        >
            <div class="error-modal__content">
                <Show when={props.error instanceof ErrorModel}>
                    <div class="error-modal__message">
                        {intl.formatMessage(messages.messageLabel)}{' '}
                        {props.error.toString() === 'Unexpected Error'
                            ? intl.formatMessage(messages.unexpectedError)
                            : props.error.toString()}
                    </div>
                    <div class="error-modal__stack">{intl.formatMessage(messages.stackLabel)} {props.error.getStack()}</div>
                </Show>
                <ButtonAtomComponent class="error-modal__close-button" onClick={props.onClose}>
                    {intl.formatMessage(messages.closeButton)}
                </ButtonAtomComponent>
            </div>
        </ModalOrganismComponent>
    )
}
